import { GlobeIcon } from '@persona-id/design-tokens/icons/16px';

import Button, { ButtonProps } from 'design-system/components/Button';
import Tooltip from 'design-system/components/Tooltip';

export const MISSING_SOURCE_TEXT_LABEL = 'No source text found to translate';
export const TRANSLATE_ALL_INFO = 'Translations are generated using Google Translate.';

type TranslateAllButtonProps = Pick<ButtonProps, 'variant' | 'isPending'> & {
  id: string;
  buttonLabel?: string;
  hasMissingSourceText: boolean;
  disabled?: boolean;
  portal?: boolean;
  handleTranslateAll: () => void;
};

const TranslateAllButton = ({
  id,
  buttonLabel = 'Translate All',
  variant,
  hasMissingSourceText,
  isPending,
  disabled,
  portal = false,
  handleTranslateAll,
}: TranslateAllButtonProps) => {
  return (
    <Tooltip
      side='top'
      portal={portal}
      trigger={
        <Button
          style={{ marginLeft: 'auto' }}
          id={`${id}-translations-inputs__translate-all-button`}
          data-cy='form-section-translations-config__translate-all-button'
          size='md'
          width='auto'
          type='button'
          variant={variant}
          aria-label={buttonLabel}
          prefixIcon={<GlobeIcon />}
          disabled={hasMissingSourceText || disabled}
          isPending={isPending}
          onClick={handleTranslateAll}
        >
          {buttonLabel}
        </Button>
      }
    >
      {hasMissingSourceText ? MISSING_SOURCE_TEXT_LABEL : TRANSLATE_ALL_INFO}
    </Tooltip>
  );
};

export default TranslateAllButton;
